import find from 'lodash/find';
import isString from 'lodash/isString';
import {push} from 'router/router-actions';
import {
    retrieveSpotTravelDistance,
    retrieveAirportSpotTravelDistance,
} from 'utils/travel-distance';
import get from 'lodash/get';

export const SPOT_UPDATE_SELECTED = 'SPOT_UPDATE_SELECTED';
export const SPOT_CHANGE_MULTI_RATE = 'SPOT_CHANGE_MULTI_RATE';
export const SPOT_SET_TERM = 'SPOT_SET_TERM';
export const SPOT_GET_TRAVEL_DISTANCE = 'SPOT_GET_TRAVEL_DISTANCE';
export const SPOT_GET_AIRPORT_TRAVEL_DISTANCE =
    'SPOT_GET_AIRPORT_TRAVEL_DISTANCE';
export const SPOT_SHOW_RATE_DETAILS = 'SPOT_SHOW_RATE_DETAILS';
export const SPOT_HIDE_RATE_DETAILS = 'SPOT_HIDE_RATE_DETAILS';
export const SPOT_TOGGLE_RATE_OVERSIZED_FEE_DETAILS =
    'SPOT_TOGGLE_RATE_OVERSIZED_FEE_DETAILS';
export const SPOT_TOGGLE_RATE_ONLINE_COMMUTER_DETAILS =
    'SPOT_TOGGLE_RATE_ONLINE_COMMUTER_DETAILS';
export const SPOT_RESET_SELECTED_SPOT = 'SPOT_RESET_SELECTED_SPOT';
export const SPOT_RESET_SELECTED_RATE = 'SPOT_RESET_SELECTED_RATE';

export const updateSelected = ({spot, referrer, goToSpotUrl = false} = {}) => {
    return dispatch => {
        dispatch({
            type: SPOT_UPDATE_SELECTED,
            payload: {
                spot,
                referrer,
                goToSpotUrl,
            },
        });

        if (goToSpotUrl && spot) {
            dispatch(push(spot.selectedRate.fullUrl));
        }
    };
};

export const selectSpot = (spotId, historyState) => (dispatch, getState) => {
    const {
        spots: {data: spots},
    } = getState();

    dispatch(
        updateSelected({
            spot: find(spots, {spotId}),
            referrer: get(historyState, 'referrer', 'list'),
        })
    );
};

export const clearSelectedSpot = () => updateSelected();

export const changeMultiRate = ({newRateRule, rates}) => {
    return {
        type: SPOT_CHANGE_MULTI_RATE,
        payload: {
            newRate: find(rates, {fullRule: parseInt(newRateRule, 10)}) || null,
            rid: parseInt(newRateRule, 10),
        },
    };
};

export const setTerm = ({newRate, rid, monthly}) => {
    return {
        type: SPOT_SET_TERM,
        payload: {
            newRate,
            rid,
            monthly,
        },
    };
};

export const showRateDetails = (section = null) => {
    return {
        type: SPOT_SHOW_RATE_DETAILS,
        payload: {
            section: isString(section) ? section : null,
        },
    };
};

export const hideRateDetails = () => {
    return {
        type: SPOT_HIDE_RATE_DETAILS,
    };
};

export const toggleOversizedFeeDetails = () => {
    return {
        type: SPOT_TOGGLE_RATE_OVERSIZED_FEE_DETAILS,
    };
};

export const toggleOnlineCommuterDetails = () => {
    return {
        type: SPOT_TOGGLE_RATE_ONLINE_COMMUTER_DETAILS,
    };
};

export const getTravelDistance = spot => {
    return {
        type: SPOT_GET_TRAVEL_DISTANCE,
        payload: retrieveSpotTravelDistance(spot),
    };
};

export const getAirportTravelDistance = spot => {
    return {
        type: SPOT_GET_AIRPORT_TRAVEL_DISTANCE,
        payload: retrieveAirportSpotTravelDistance(spot),
    };
};

export const resetSelectedSpot = () => {
    return {
        type: SPOT_RESET_SELECTED_SPOT,
    };
};

export const resetSelectedRate = () => {
    return {
        type: SPOT_RESET_SELECTED_RATE,
    };
};
